// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CarouselSendPanel's own classes — everything else it renders reuses the library's nic-tm-/
   Carousel- classes (see TemplateMessaging.css, Components/Footer/index.css,
   Components/Carousel/index.css, all loaded globally by the package import). Swap-out plan: see
   ../README.md — deleted along with the rest of this folder. */

.br-carousel-send-skip-note {
  color: var(--br-text-muted, #6b7280);
  margin: 0;
}

.br-carousel-send-tab-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.br-carousel-send-tab-error {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--br-error, #d32f2f);
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/templateSend/carousel/carousel.css"],"names":[],"mappings":"AAAA;;;+DAG+D;;AAE/D;EACE,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB","sourcesContent":["/* CarouselSendPanel's own classes — everything else it renders reuses the library's nic-tm-/\n   Carousel- classes (see TemplateMessaging.css, Components/Footer/index.css,\n   Components/Carousel/index.css, all loaded globally by the package import). Swap-out plan: see\n   ../README.md — deleted along with the rest of this folder. */\n\n.br-carousel-send-skip-note {\n  color: var(--br-text-muted, #6b7280);\n  margin: 0;\n}\n\n.br-carousel-send-tab-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.br-carousel-send-tab-error {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--br-error, #d32f2f);\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
